/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Card_Designer_DescriptionInputs */



/**
* | output |
* | --- |
* | "Make a custom card with your own background image" |
*
* @param {Nav_Card_Designer_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_card_designer_description = /** @type {((inputs?: Nav_Card_Designer_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Card_Designer_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine eigene Karte mit deinem Hintergrundbild bauen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créez une carte personnalisée avec votre propre image de fond")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("用你自己的背景图制作自定义卡牌")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("用你自己的背景圖製作一張自訂卡牌")
	if (locale === "ko") return /** @type {LocalizedString} */ ("직접 준비한 배경 이미지로 커스텀 카드 제작")
	return /** @type {LocalizedString} */ ("Make a custom card with your own background image")
});